import { useEffect, useState, useRef, useCallback } from 'react';

function randomString(len) {
    const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < len; i++) {
        const randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
}

export default function useWebSocket({ token, onMessage, onOpen }) {
    const [isConnected, setWebSocketConnected] = useState(false);
    const localIdRef = useRef(randomString(10));
    const webSocketRef = useRef(null);

    const send = useCallback((to, type, content) => {
        const message = {
            from: localIdRef.current,
            to,
            requestId: "noRequestId",
            type,
            content
        };
        console.log(`Sending message: ${JSON.stringify(message)}`);
        webSocketRef.current.send(JSON.stringify(message));
    }, []);

    useEffect(() => {

        const server = `${process.env.REACT_APP_BACKEND_WS}`;
	    console.log(server);
        const url = `${server}?peerId=${localIdRef.current}&jwt=${token}`;
        const webSocket = new WebSocket(url);
        console.log(`Opening webSocket to ${url} ...`);

        webSocket.onopen = () => {
            setWebSocketConnected(true);
            console.log(`WebSocket opened`);
            onOpen();
        };

        webSocket.onclose = () => {
            setWebSocketConnected(false);
            console.log('Closed websocket');
        };

        webSocket.onerror = (event) => {
            console.error('Error on websocket');
            console.error(event);
        };

        webSocket.onmessage = (event) => {
            onMessage(JSON.parse(event.data));
        };

        webSocketRef.current = webSocket;

        return () => {
            webSocket.close();
        }

        // The comment below supresses a warning, the array [] is empty on purpose to
        // prevent resets of the connection when the token or callback methods change.

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isConnected, send };
}
